<template>
  <div class="special_home_container" ref="homePage">
    <div class="special_info" v-if="!!detail">
      <!-- 默认大图 -->
      <div class="special_detault_img" v-if="detail.indexBackMode == 0">
        <div class="img">
          <img :src="detail.bigResouceUrl" :onerror="imgLoadError(detail)" alt="" />
        </div>
      </div>
      <!-- 背景海报、多张 -->
      <div class="special_poster_imgs" v-else-if="detail.indexBackMode == 1 && detail.backPosterPicArray.length>0" :style="{ height: posterHeight }">
        <div class="swipe_box">
          <van-swipe :show-indicators="true" :loop="true" :autoplay="3000">
            <van-swipe-item v-for="(item, index) in detail.backPosterPicArray" :key="index">
              <div class="img" :style="{backgroundImage:'url(' +(item.picUrl == ''? require('@/assets/images/user_default.png'): item.picUrl) +')',}"></div>
            </van-swipe-item>
          </van-swipe>
        </div>
      </div>
      <!-- 背景方图、多张 -->
      <div class="special_block_imgs" v-else-if="detail.indexBackMode == 2 && detail.backBlockPicArray.length>0">
        <div class="swipe_box">
          <van-swipe :show-indicators="true" :loop="true" :autoplay="3000">
            <van-swipe-item v-for="(item, index) in detail.backBlockPicArray" :key="index">
              <div class="img" :style="{backgroundImage:'url(' +(item.picUrl == ''? require('@/assets/images/user_default.png'): item.picUrl) +')',}"></div>
            </van-swipe-item>
          </van-swipe>
        </div>
      </div>
      <!-- 普通大图、多张 -->
      <div class="special_normal_imgs" v-else-if="detail.indexBackMode == 3 && detail.backNormalPicArray.length>0">
        <div class="swipe_box">
          <van-swipe :show-indicators="true" :loop="true" :autoplay="3000">
            <van-swipe-item v-for="(item, index) in detail.backNormalPicArray" :key="index">
              <div class="img" :style="{backgroundImage:'url(' +(item.picUrl == ''? require('@/assets/images/user_default.png'): item.picUrl) +')',}"></div>
            </van-swipe-item>
          </van-swipe>
        </div>
      </div>
      <!-- 默认大图 -->
      <div class="special_detault_img" v-else>
        <div class="img">
          <img :src="detail.bigResouceUrl" :onerror="imgLoadError(detail)" alt="" />
        </div>
      </div>
      <div class="special_introduction">
        <span v-text="detail.introduction"></span>
      </div>
      <div class="special_category" v-if="specialCategoryList.length > 0">
        <ul>
          <li class="category_item" v-for="(item, index) in specialCategoryList" :key="index" v-text="item.name" @click="toCategoryLocation(index)"></li>
        </ul>
      </div>
    </div>
    <div class="cate_content_list" v-if="specialNewsList.length>0">
      <div v-for="(item, index) in specialNewsList" :key="index" class="content_list_item">
        <div class="cate_label" ref="location">
          <div class="cate_title" v-text="item.data.classifyName" v-if="!!item.data"></div>
          <label class="more" @click="toCategoryContentList(index)">更多&gt;</label>
        </div>
        <div class="content_list" v-if="!!item.data">
          <news-list class="special_news_list" :contentList="item.data.list" :deviceId="deviceId"></news-list>
        </div>
        <!-- <div class="more_list">
          <span class="more" @click="toCategoryContentList(index)">查看更多</span>
        </div> -->
      </div>
    </div>
  </div>
</template>
<script>
import specialApi from "@/api/apis/special.js";
import NewsList from "./SpecialNewsList";
export default {
  name: "specialTemplate002",
  props: {
    contentId: {
      type: Number,
      default: null,
    },
    deviceId: {
      type: String,
      default: null,
    },
    detail: {
      type: Object,
      default: null,
    }
  },
  components: {
    NewsList,
  },
  data() {
    return {
      headerHidden: false, // 是否隐藏顶部
      posterHeight: "auto",
      specialCategoryList: [], //专题内容分类
      specialNewsList: [], //专题内容列表
    };
  },
  methods: {
    imgLoadError(item) {
      // console.log("加载默认图片");
    },
    /* 点击专题分类,滚动到指定的锚点 */
    toCategoryLocation(index) {
      let top = this.$refs.location[index].offsetTop;
      this.$nextTick(() => {
        this.$refs.homePage.scrollTo({
          top: top,
          left: 0,
          behavior: "smooth",
        });
      });
    },
    /* 点击更多，跳转专题分类内容列表 */
    toCategoryContentList(index) {
      let id = this.specialCategoryList[index].id;
      var q = {
        contentType: "special_content_list",
        contentId: id,
        specialId: id,
      }
      if (!!this.headerHidden) {
        q = Object.assign(q, { client: 1 });
      }
      this.$router.push({
        path: "/special_more",
        query: q,
      });
    },
    /* 获取专题稿件分类 */
    getSpecialById() {
      var _this = this;
      var params = { contentId: _this.contentId };
      specialApi
        .getSpecialById(params)
        .then((res) => {
          if (res.suc == 1) {
            _this.specialCategoryList = res.data.list;
            for (var i = 0; i < _this.specialCategoryList.length; i++) {
              _this.specialNewsList.push({
                id: _this.specialCategoryList[i].id,
                data: null,
              });
              _this.getSpecialContentsByClassifyId(
                _this.specialCategoryList[i].id
              );
            }
          } else {
            _this.$toast({
              message: res.message,
              position: "center",
            });
          }
        })
        .catch((err) => {
          _this.$toast({
            message: "接口调用出错",
            position: "center",
          });
        });
    },
    /* 根据专题内容分类Id获取专题内容列表 */
    getSpecialContentsByClassifyId(id) {
      var _this = this;
      var params = {
        currentPage: 0,
        pageSize: 5, // 锚点类型最多5条数据
        contentClassifyId: id,
      };
      specialApi
        .getSpecialContentsByClassifyId(params)
        .then((res) => {
          if (res.suc == 1) {
            _this.specialNewsList.map(function (obj) {
              if (obj.id == id) {
                obj.data = res.data;
              }
            }, id);
          } else {
            _this.$toast({
              message: res.message,
              position: "center",
            });
          }
        })
        .catch((err) => {
          _this.$toast({
            message: "接口调用出错",
            position: "center",
          });
        });
    },
  },
  created() {
    if (!!this.contentId) {
      this.getSpecialById(); //获取专题稿件分类
    }
    let query = this.$route.query;
    if (Object.prototype.hasOwnProperty.call(query, "client")) {
      if (query.client == 1 || query.client == '1' || query.client == true || query.client == 'true') {
        this.headerHidden = true;
      }
    }
  },
  updated() {
    var ele1 = document.getElementsByClassName("top_header");
    let h1 = 0;
    if (ele1.length > 0) {
      h1 = ele1[0].clientHeight;
    }
    this.posterHeight = window.innerHeight - h1 + "px";
  },
};
</script>
<style scoped lang="scss">
.special_home_container {
  width: 100%;
  height: 100%;
  padding: 0;
  overflow-x: hidden;
  overflow-y: auto;
  background-color: #f0eff8;
  .special_info {
    background-color: #fff;
    /* 默认大图 */
    .special_detault_img {
      position: relative;
      width: 100%;
      height: 0;
      padding-bottom: 56.25%;
      background-repeat: no-repeat;
      background-size: cover;
      background-position: center center;
      background-image: url(~@/assets/images/default_pic_16_9.png);
      overflow: hidden;
      .img {
        position: absolute;
        top: 0;
        left: 0;
        z-index: 1;
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        img {
          object-fit: cover;
          min-width: 100%;
          min-height: 100%;
        }
      }
    }
    /* 海报 */
    .special_poster_imgs {
      position: relative;
      width: 100%;
      height: 100%;
      overflow: hidden;
      .swipe_box {
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        .van-swipe {
          width: 100%;
          height: 100%;
          .van-swipe-item {
            .img {
              width: 100%;
              height: 100%;
              background-repeat: no-repeat;
              background-position: center;
              background-size: cover;
            }
          }
        }
      }
    }
    /* 方图 */
    .special_block_imgs {
      position: relative;
      width: 100%;
      height: 0;
      padding-bottom: 100%;
      overflow: hidden;
      .swipe_box {
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        .van-swipe {
          width: 100%;
          height: 100%;
          .van-swipe-item {
            .img {
              width: 100%;
              height: 100%;
              background-repeat: no-repeat;
              background-position: center;
              background-size: cover;
            }
          }
        }
      }
    }
    /* 普通大图 */
    .special_normal_imgs {
      position: relative;
      width: 100%;
      height: 0;
      padding-bottom: 56.25%;
      overflow: hidden;
      .swipe_box {
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        .van-swipe {
          width: 100%;
          height: 100%;
          .van-swipe-item {
            .img {
              width: 100%;
              height: 100%;
              background-repeat: no-repeat;
              background-position: center;
              background-size: cover;
            }
          }
        }
      }
    }
    .special_introduction {
      padding: 10px 10px 0;
      color: #868686;
    }
    .special_category {
      padding: 10px 5px;
      border-bottom: 5px solid #f0eff8;
      ul {
        .category_item {
          display: inline-block;
          padding: 3px 10px;
          border: 1px solid #ddd;
          margin: 5px;
          border-radius: 3px;
          font-size: 13px;
          cursor: pointer;
        }
      }
    }
  }
  .cate_content_list {
    .content_list_item {
      background: #fff;
      margin-bottom: 5px;
      .cate_label {
        position: relative;
        height: 36px;
        padding-left: 20px;
        padding-right: 15px;
        border-top: 1px solid #ececec;
        border-bottom: 1px solid #ececec;
        line-height: 36px;
        overflow: hidden;
        &:before {
          position: absolute;
          left: 10px;
          top: 9px;
          display: block;
          width: 5px;
          height: 18px;
          background-color: #d71e02;
          content: "";
        }
        .cate_title {
          display: inline-block;
          max-width: calc(100% - 50px);
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        .more {
          float: right;
          color: #999;
          font-size: 13px;
          cursor: pointer;
          &:active {
            opacity: 0.7;
          }
        }
      }
      .content_list {
        padding: 0 15px;
      }
      /* .more_list {
        padding: 10px;
        text-align: center;
        .more {
          color: #333;
          font-size: 14px;
          cursor: pointer;
        }
      } */
    }
  }
}
</style>